enum Role {
	USER = "user",
	MANAGER = "manager",
	ADMIN = "admin",
}

export enum ExtraPermission {
	VIEW_IMAGES = "view-images",
	VIEW_HIDDEN_GROUPS = "view-hidden-groups",
}

export const extraPermissionNiceName: Record<ExtraPermission, string> = {
	"view-hidden-groups": "View hidden groups",
	"view-images": "View images",
};

export default Role;
